import { Environment } from "src/env";
import { AlbumApi, BannerApi, Configuration as DownloadConfiguration, CuratedSetApi, MediaApi, MetaApi, OnlineCrateApi, PlaylistApi, UserPlaylistApi } from "./download-api-sdk/src";
import { Configuration } from "./supreme-api-sdk/src";

const parseCookie = () =>
    document.cookie
        .split(';')
        .map((v) => v.split('='))
        .reduce((acc, v) => {
            const key = decodeURIComponent(v[0].trim());
            acc[key] = decodeURIComponent(v[1].trim());
            return acc;
        }, {} as { [key: string]: string });

export const apiKey = () => {
    const cookies = parseCookie();
    // eslint-disable-next-line @typescript-eslint/dot-notation
    if (cookies['bpm_session']) {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        return `Bearer ${cookies['bpm_session']}`;
    }
    return '';
};

export const supremeConfig = new Configuration({
    basePath: `${Environment.API}/v4`,
    includeCredentials: true,
    apiKey
});

export const downloadConfig = new DownloadConfiguration({
    basePath: Environment.API_DOWNLOAD,
    includeCredentials: true,
    apiKey
});

export const mediaAPI = new MediaApi(downloadConfig);
export const albumAPI = new AlbumApi(downloadConfig);
export const playlistAPI = new PlaylistApi(downloadConfig);
export const userPlaylistAPI = new UserPlaylistApi(downloadConfig);
export const curatedSetsAPI = new CuratedSetApi(downloadConfig);
export const crateAPI = new OnlineCrateApi(downloadConfig);
export const metaAPI = new MetaApi(downloadConfig);
export const bannerAPI = new BannerApi(downloadConfig);


// WEBPACK FOOTER //
// ./src/api/config.ts